import { Action } from '@ngrx/store';
import { UserMarketingSetting } from '@model';

export enum UserMarketingSettingsActionTypes {
  UserMarketingSettingsLoadData = '[UserMarketingSettings] Load data',
  UserMarketingSettingsLoadDataSuccess = '[UserMarketingSettings] Load success',
  UserMarketingSettingsLoadDataFail = '[UserMarketingSettings] Load fail',
  UserMarketingSettingsUpdate = '[UserMarketingSettings] Update data',
  UserMarketingSettingsUpdateSuccess = '[UserMarketingSettings] Update success',
  UserMarketingSettingsUpdateFail = '[UserMarketingSettings] Update fail'
}

export class UserMarketingSettingsLoad implements Action {
  readonly type = UserMarketingSettingsActionTypes.UserMarketingSettingsLoadData;
  constructor() {}
}
export class UserMarketingSettingsLoadSuccess implements Action {
  readonly type = UserMarketingSettingsActionTypes.UserMarketingSettingsLoadDataSuccess;
  constructor(public payload: UserMarketingSetting) {}
}
export class UserMarketingSettingsLoadFail implements Action {
  readonly type = UserMarketingSettingsActionTypes.UserMarketingSettingsLoadDataFail;
  constructor(public payload: any) {}
}

export class UserMarketingSettingsUpdate implements Action {
  readonly type = UserMarketingSettingsActionTypes.UserMarketingSettingsUpdate;
  constructor(public payload: UserMarketingSetting) {}
}

export class UserMarketingSettingsUpdateSuccess implements Action {
  readonly type = UserMarketingSettingsActionTypes.UserMarketingSettingsUpdateSuccess;
  constructor(public payload: UserMarketingSetting) {}
}

export class UserMarketingSettingsUpdateFail implements Action {
  readonly type = UserMarketingSettingsActionTypes.UserMarketingSettingsUpdateFail;
  constructor(public payload: any) {}
}

export type UserMarketingSettingsAction =
  | UserMarketingSettingsLoad
  | UserMarketingSettingsLoadSuccess
  | UserMarketingSettingsLoadFail
  | UserMarketingSettingsUpdate
  | UserMarketingSettingsUpdateSuccess
  | UserMarketingSettingsUpdateFail;
